import client from './client';

export interface Investor {
  tags?:Array<{id:number;label:string;color:string}>;
  investor_id: number;
  investor_uuid_id: string;
  investor_name: string;
  manager_name: string | null;
  manager_surname: string | null;
  investor_manager_fullname: string | null;
  email: string | null;
  phone: string | null;
  address: string | null;
  subdomain: string | null;
  ai_provider: 'gemini'|'openai';
  status: number;
  plant_count: number;
  investor_power_plant_e_day: number;
  investor_power_plant_e_total: number;
  logo_url?: string | null;
}

export async function fetchInvestors(): Promise<Investor[]> {
  const res = await client.get<Investor[]>('/investors');
  return res.data;
}

export interface InvestorPlant {
  power_plant_id: number;
  power_plant_uuid_id: string;
  power_plant_name: string;
  power_plant_e_day: number;
  power_plant_e_total: number;
  power_plant_status: number;
  power_plant_last_seen: string | null;
}

export interface InvestorDetailResponse {
  investor: Investor;
  plants: InvestorPlant[];
}

export async function fetchInvestorDetail(
  uuid_id: string,
): Promise<InvestorDetailResponse> {
  const res = await client.get<InvestorDetailResponse>(`/investors/${uuid_id}`);
  return res.data;
}

export interface InvestorUpdatePayload {
  investor_name: string;
  manager_name: string;
  manager_surname: string;
  email: string;
  phone: string;
  address: string;
  subdomain: string;
  ai_provider: 'gemini'|'openai';
  status: number;
}

export async function createInvestor(data: InvestorUpdatePayload): Promise<{ uuid_id: string }> {
  const res = await client.post<{ uuid_id: string }>('/investors', data);
  return res.data;
}

export async function updateInvestor(uuid_id: string, data: InvestorUpdatePayload): Promise<void> {
  await client.put(`/investors/${uuid_id}`, data);
}

export async function deleteInvestor(uuid_id: string): Promise<void> {
  await client.delete(`/investors/${uuid_id}`);
}

export async function uploadInvestorLogo(uuidId: string, file: File): Promise<{ logo_url: string }> {
  const formData = new FormData();
  formData.append('logo', file);
  const res = await client.post<{ logo_url: string }>(`/investors/${uuidId}/logo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}

export async function deleteInvestorLogo(uuidId: string): Promise<void> {
  await client.delete(`/investors/${uuidId}/logo`);
}
